import { useEffect, useState } from "react";
import { isMobileMailViewport } from "@/lib/device/isMobileMail";

export function useIsMobileMail(): boolean {
  const [mobile, setMobile] = useState(() => isMobileMailViewport());

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const onChange = () => setMobile(mq.matches);
    mq.addEventListener("change", onChange);
    setMobile(mq.matches);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return mobile;
}
